import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./slices/ui";
import supplierReducer from "./slices/supplier";
import dailyReportsReducer from "./slices/dailyReports";
import periodReportsReducer from "./slices/periodReports";
import promitheiesReducer from "./slices/promitheies";

const store = configureStore({
  reducer: {
    ui: uiReducer,
    suppliers: supplierReducer,
    dailyReports: dailyReportsReducer,
    periodReports: periodReportsReducer,
    ekkathariseis: promitheiesReducer,
  },
});

export default store;
